import React from 'react'

// Constants
import { colors, tenantColors } from '../../../../_constants/colors'

// Styles
import {
  S_VerificationDetailsContent,
  S_VerificationDetailsPieSection,
  S_VerificationRequirementSection,
  S_NoVerificationData,
} from './ScheduleDetails.styles'

// Components
import { ProgressBar } from '../../../../_components/ProgressBar/ProgressBar'
import { tenantSelectors } from '../../../../_selectors/tenant.selectors'
import { formatValueByType } from '../../../../_helpers'
import { tint } from 'polished'

import { PieChart } from '../../../../components/Chart/PieChart/PieChart'
import { H3 } from '../../../../_components/Typography/Components/Headings/H3'

export const VerificationDetails = ({ details }) => {
  const tenant = tenantSelectors.useTenant()
  const pieChartSize = 200

  const {
    positive_percent,
    neutral_percent,
    negative_percent,
    schedule_total,
    positive_total,
    neutral_total,
    negative_total,
  } = details

  const totalPercent = Number(positive_percent) + Number(neutral_percent) + Number(negative_percent)
  const totalValues = Number(positive_total) + Number(neutral_total) + Number(negative_total)
  const shadowId = 'PieChartShadow'
  let pieData = []

  const verificationData = [
    {
      name: 'Verified',
      value: Number(positive_total),
      percent: positive_percent,
    },
    {
      name: 'Neutral',
      value: Number(neutral_total),
      percent: neutral_percent,
    },
    {
      name: 'Negative',
      value: Number(negative_total),
      percent: negative_percent,
    },
  ]

  if (totalPercent < 1) {
    verificationData.push({
      name: 'Invoices with No Notes',
      value: Number(schedule_total) - totalValues,
      percent: 1 - totalPercent,
    })
  }

  // Sort array by value
  const sortedVerificationData = verificationData.sort((a, b) => (a.value > b.value ? -1 : 1))

  pieData = sortedVerificationData.map((item, index) => {
    return {
      ...item,
      strokeWidth: 0,
      percentage: `${(Number(item.percent) * 100).toFixed(0)}%`,
      color: tint(index / (sortedVerificationData.length + 1), colors.DEFAULT_SECONDARY),
      fill: tint(index / (sortedVerificationData.length + 1), colors.DEFAULT_SECONDARY),
    }
  })

  const formatTooltipValue = (value, name, props) => {
    const currencyValue = formatValueByType(value, 'currency')
    const percentageValue = props.payload.percentage
    return `${currencyValue} (${percentageValue})`
  }

  const renderPieChart = () => {
    const shouldRender = details.schedule_total > 0
    if (!shouldRender) {
      return <S_NoVerificationData>No Verification Information Available</S_NoVerificationData>
    }

    return (
      <>
        <PieChart
          data={pieData}
          dataKey="value"
          height={pieChartSize}
          legendDataKey="percentage"
          nameKey="name"
          showLegend={true}
          toolTipFormatter={formatTooltipValue}
        />
      </>
    )
  }

  const renderVerificationRequirement = () => {
    return (
      <ProgressBar
        bgcolor={tenantColors[tenant].positiveVerification}
        details={details}
        key={'verification-requirements-bar'}
      />
    )
  }

  return (
    <S_VerificationDetailsContent>
      <H3 fw={400} mb={'10px'}>
        Invoice Schedule Verifications
      </H3>
      <S_VerificationDetailsPieSection>{renderPieChart()}</S_VerificationDetailsPieSection>

      <H3 fw={400} mb={'10px'}>
        Client Verifications with Invoice Schedule
      </H3>
      <S_VerificationRequirementSection>{renderVerificationRequirement()}</S_VerificationRequirementSection>
    </S_VerificationDetailsContent>
  )
}
